// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__XaPDZ","container":"Home_container__97eC3","header":"Home_header__CyQ_T","loaderContainer":"Home_loaderContainer__g6gOs","footer":"Home_footer__zed0_"};